export const coursEducData = [
  {
    title: "Forfait Poupi",
    subtitle: "240€",
    image: "poupi.png",
    description: "3 cours d'éducation"
  },
  {
    title: "Forfait Mimosa",
    subtitle: "350€",
    image: "mimosa.png",
    description: "5 cours d'éducation"
  },
  {
    title: "Forfait Volt",
    subtitle: "485€",
    image: "volt.png",
    description: "7 cours d'éducation"
  },
  {
    title: "Forfait Saga",
    subtitle: "680€",
    image: "saga.png",
    description: "10 cours d'éducation"
  }
];